import { validate as isValidCnpj } from "node-cnpj";
import { validate as isValidCpf } from "node-cpf";

const Validators = (...validators) => value => {
  return validators.reduce((error, validator) => error || validator(value), undefined)
}
export default Validators;

export const required = data => {
  if (!data || data === '') {
      return 'Este campo é obrigatório.';
  }

  return undefined;
}

export const isNumber = data => {
  if (Number(data) != data && data != undefined) {
    return "Esta campo tem que ser numerico."
  }

  return undefined;
}

const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

export const validateDocument = value => {
  if (!value) {
    return 'Informe ou CPF ou CNPJ.';
  }
  const digits = value.replace(/[^\d]/g, '');
  if (digits.length <= CPF_LENGTH) {
    return validateCpf(digits);
  }
  return validateCnpj(digits);
}

const validateCpf = value => {
  if (value.length < CPF_LENGTH) {
    return 'CPF incompleto.';
  } else if (!isValidCpf(value)) {
    return 'CPF inválido.';
  }
}

const validateCnpj = value => {
  if (value.length < CNPJ_LENGTH) {
    return 'CNPJ incompleto.';
  } else if (!isValidCnpj(value)) {
    return 'CNPJ inválido.';
  }
}


// WEBPACK FOOTER //
// ./src/Common/validators.js